import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'
import { cn } from '../../lib/utils'

export interface UIBadgeWithImageProps extends UIBadgeProps {
  /**
   * 이미지 URL
   */
  src?: string
  /**
   * 이미지 alt 텍스트
   */
  alt?: string
  /**
   * 이미지 크기 클래스명 (기본값: "w-5 h-5")
   */
  imageClassName?: string
}

/**
 * UIBadgeWithImage - Image Badge Block
 * 이미지가 포함된 배지 컴포넌트입니다.
 */
export const UIBadgeWithImage = React.forwardRef<
  React.ComponentRef<typeof UIBadge>,
  UIBadgeWithImageProps
>(({ src = "https://github.com/shadcn.png", alt = "shadcn", imageClassName, className, children, ...props }, ref) => (
  <UIBadge ref={ref} className={cn("gap-2", className)} {...props}>
    <img
      src={src}
      alt={alt}
      className={cn("w-5 h-5 rounded-full", imageClassName)}
    />
    {children ?? "shadcn"}
  </UIBadge>
))

UIBadgeWithImage.displayName = "UIBadgeWithImage"